import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaChevronDown, FaChevronUp, FaEye, FaEyeDropper, FaEyeSlash, FaNewspaper, FaRegArrowAltCircleLeft, FaLanguage } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';

const Resultat_principe = ({ titre }) => {
    useAuth();
    const [qcms, setQcms] = useState([]);
    const [examen, setExamen] = useState([]);
    const [data, setData] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showInfo, setShowInfo] = useState(false);
    const [afficherResultats, setAfficherResultats] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [langueActuelle, setLangueActuelle] = useState('fr'); // 'fr' ou 'ang'

    const location = useLocation();
    const { examen_id } = location.state || {};
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Terminer";
        }
    }, [user_id]);

    const [examenblancDetails, setExamenblancDetails] = useState([]);

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            handleFinishExamen()
        }, 3000);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const itemsParPage = 5;

    const totalPages = Math.ceil(qcms.length / itemsParPage);

    const debutIndex = (currentPage - 1) * itemsParPage;
    const finIndex = debutIndex + itemsParPage;
    const currentQcms = qcms.slice(debutIndex, finIndex);

    const pageSuivante = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const pagePrecedente = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleFinishExamen = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-qcms-principe/${user_id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                setIsLoading(false)
                const data = await response.json();
                console.log('data qcm refonte', data)
                setData(data);
                setQcms(data.qcms)
                // Définir la langue initiale basée sur les données reçues
                if (data.langue) {
                    setLangueActuelle(data.langue.toLowerCase());
                }
            } else {
                setIsLoading(false)
                console.error('Erreur lors de la récupérationnnn');
            }
        } catch (error) {
            setIsLoading(false)
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        handleFinishExamen();
    }, []);

    // Fonction pour changer la langue
    const changerLangue = () => {
        setLangueActuelle(prevLangue => prevLangue === 'fr' ? 'ang' : 'fr');
    };

    // Filtrer les QCMs par langue
    const qcmsFiltres = qcms.filter(qcm => {
        if (langueActuelle === 'fr') {
            return qcm.langue === 'fr' || !qcm.langue; // Inclure ceux sans langue définie
        } else {
            return qcm.langue === 'ang';
        }
    });

    const currentQcmsFiltres = qcmsFiltres.slice(debutIndex, finIndex);
    const totalPagesFiltres = Math.ceil(qcmsFiltres.length / itemsParPage);

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2><FaNewspaper size={25} className='mr-2' />
                                    Résultat 50 principes
                                </h2>
                                {/* <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span> */}
                            </div>
                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-complet`}> Simulateur </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Résultat {examen_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-10 mx-auto">
                                <div className="ibox ">
                                    {/* En-tête avec bouton de langue */}
                                    <div className="ibox-title p-3">
                                        <div className='p-2 d-flex align-items-center justify-content-between'>
                                            <h5>
                                                QCMs {langueActuelle === 'fr' ? 'Français' : 'Anglais'}
                                                <span className="badge badge-primary ml-2">
                                                    {qcmsFiltres.length} question(s)
                                                </span>
                                            </h5>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex align-items-center">
                                                        <div className="btn-group ml-2" style={{ width: '100px' }}>
                                                            {/* Option Français */}
                                                            <button
                                                                onClick={changerLangue}
                                                                className={`btn btn-xs ${langueActuelle === 'fr' ? 'btn-success' : ''}`}
                                                                disabled={langueActuelle === 'fr'}
                                                                style={{
                                                                    fontSize: '12px',
                                                                    fontWeight: '600',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    gap: '4px'
                                                                }}
                                                            >
                                                                {/* <span>🇫🇷</span> */}
                                                                FR
                                                            </button>

                                                            {/* Option Anglais */}
                                                            <button
                                                                onClick={changerLangue}
                                                                className={`btn btn-xs ${langueActuelle === 'ang' ? 'btn-success' : ''}`}
                                                                disabled={langueActuelle === 'ang'}
                                                                style={{
                                                                    fontSize: '12px',
                                                                    fontWeight: '600',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    gap: '4px'
                                                                }}
                                                            >
                                                                {/* <span>🇬🇧</span> */}
                                                                EN
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <span
                                                    className='label label-primary mb-2'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setAfficherResultats(!afficherResultats)}
                                                >
                                                    <span className='mr-2'>Voir corrigé</span>
                                                    {afficherResultats ? <FaEye /> : <FaEyeSlash />}
                                                </span> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ibox-content">
                                        {isLoading ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border text-success" role="status">
                                                    <span className="sr-only">Chargement...</span>
                                                </div>
                                                <p className="mt-2">Chargement des QCMs Principe...</p>
                                            </div>
                                        ) : (
                                            <div>
                                                {
                                                    afficherResultats && (
                                                        <div className={`${afficherResultats ? "open" : ""}`}>
                                                            {currentQcmsFiltres.length > 0 ? (
                                                                currentQcmsFiltres.map((qcm) => (
                                                                    <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px', fontSize: '12px' }}>
                                                                        <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcm.id} />

                                                                        <div>
                                                                            <span># {qcm.ref} - </span>
                                                                            <span id="question" style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                                            {/* {qcm.langue && (
                                                                            <span className="badge badge-secondary ml-2">
                                                                                {qcm.langue.toUpperCase()}
                                                                            </span>
                                                                        )} */}
                                                                        </div>

                                                                        <div style={{ margin: '10px 10px' }}>
                                                                            {Object.keys(qcm)
                                                                                .filter((key) => key.startsWith('option') && (qcm[key] !== 'non défini' && qcm[key] !== 'vide'))
                                                                                .map((key, index) => {
                                                                                    const optionLetter = String.fromCharCode(65 + index); // Générer A, B, C, ...
                                                                                    const optionText = qcm[key]; // Texte de l'option
                                                                                    const isCorrect = Array.isArray(qcm.reponse) && qcm.reponse.includes(optionLetter);
                                                                                    const isSelected = Array.isArray(qcm.resultat) && qcm.resultat.includes(optionLetter);

                                                                                    return (
                                                                                        <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontSize: '12px' }}>
                                                                                            <span style={{ marginRight: '10px' }}>
                                                                                                {optionLetter} - {optionText}
                                                                                            </span>

                                                                                            {/* Gestion des icônes selon les réponses et sélections */}
                                                                                            {isCorrect && isSelected ? (
                                                                                                <i className="fa fa-thumbs-up fa-2x" style={{ color: 'green', marginLeft: '5px' }} title="Correct Answer (Selected)"></i>
                                                                                            ) : isCorrect ? (
                                                                                                <i className="fa fa-thumbs-up fa-2x" style={{ color: 'green', marginLeft: '5px' }} title="Correct Answer"></i>
                                                                                            ) : isSelected ? (
                                                                                                <i className="fa fa-thumbs-down fa-2x" style={{ color: 'red', marginLeft: '5px' }} title="Incorrect Answer (Selected)"></i>
                                                                                            ) : null}
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                        </div>

                                                                        <div style={{ marginTop: '10px', fontStyle: 'italic', color: 'blue' }}>
                                                                            <p>Bonnes réponses : {qcm.reponse.join(' , ')}</p>
                                                                        </div>

                                                                        {qcm.explication && qcm.explication !== 'non défini' && (
                                                                            <div style={{ color: 'green' }}>
                                                                                <span>Explication : </span>
                                                                                <span id="explication" style={{ fontSize: '12px', color: 'green', marginTop: '10px' }} dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div className="text-center p-4">
                                                                    <p>Aucun QCM trouvé en {langueActuelle === 'fr' ? 'français' : 'anglais'}.</p>
                                                                    <Button
                                                                        variant="outline-primary"
                                                                        onClick={changerLangue}
                                                                        className="d-flex align-items-center mx-auto"
                                                                    >
                                                                        <FaLanguage className="mr-1" />
                                                                        Voir en {langueActuelle === 'fr' ? 'anglais' : 'français'}
                                                                    </Button>
                                                                </div>
                                                            )}

                                                            {/* Pagination controls */}
                                                            {totalPagesFiltres > 1 && (
                                                                <div className="d-flex align-items-center mt-4 mb-4">
                                                                    {currentPage > 1 && (
                                                                        <Button className="btn btn-success me-2" onClick={pagePrecedente}>
                                                                            <FaArrowAltCircleLeft />
                                                                        </Button>
                                                                    )}

                                                                    <span className="flex-grow-1 text-center">
                                                                        Page {currentPage} sur {totalPagesFiltres}
                                                                        {/* ({qcmsFiltres.length} QCM(s) {langueActuelle === 'fr' ? 'français' : 'anglais'}) */}
                                                                    </span>

                                                                    {currentPage < totalPagesFiltres && (
                                                                        <Button className="btn btn-success ms-2" onClick={pageSuivante}>
                                                                            <FaArrowAltCircleRight />
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-end align-items-center mt-4">
                                            {/* <Button
                                                className='btn btn-outline-secondary d-flex align-items-center'
                                                onClick={changerLangue}
                                            >
                                                <FaLanguage className='mr-1' /> 
                                                Passer en {langueActuelle === 'fr' ? 'anglais' : 'français'}
                                            </Button> */}

                                            <Button
                                                className='btn btn-success d-flex align-items-center justify-between'
                                                onClick={() => navigate('/Historique-complet')}
                                            >
                                                <FaRegArrowAltCircleLeft className='mr-1' /> Retour à la liste des examens
                                            </Button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Resultat_principe;